import { Link } from 'react-router-dom'
import Box from '@mui/material/Box'
import List from '@mui/material/List'
import Divider from '@mui/material/Divider'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered'
import PeopleIcon from '@mui/icons-material/People'
import InfoIcon from '@mui/icons-material/Info'
import LogoutIcon from '@mui/icons-material/Logout'
import Button from '@mui/material/Button'


const FamilyDrawerList = (toggleDrawer, handleLogout, linkStyle, lang) => {
    return (
        <Box role="presentation" onClick={toggleDrawer(false)}>
            <List>
                <Link to='/'>
                    <ListItem key="Patients" style={linkStyle}>
                        <ListItemIcon>
                            <PeopleIcon />
                        </ListItemIcon>
                        <ListItemText primary={lang.get("Patients")} sx={{ marginLeft: -3 }} />
                    </ListItem>
                </Link>
                <Link to='/notes-report'>
                    <ListItem key="Notes" style={linkStyle} sx={{ marginTop: -1.5 }}>
                        <ListItemIcon>
                            <FormatListNumberedIcon />
                        </ListItemIcon>
                        <ListItemText primary={lang.get("Notes")} sx={{ marginLeft: -3 }} />
                    </ListItem>
                </Link>
            </List>
            <Divider />
            <List>
                <ListItem key="Info" style={linkStyle}>
                    <ListItemIcon>
                        <InfoIcon />
                    </ListItemIcon>
                    <ListItemText primary={lang.get("Info")} sx={{ marginLeft: -3 }} />
                </ListItem>
            </List>
            <Button
                variant="contained"
                onClick={handleLogout}
                startIcon={<LogoutIcon />}
                sx={{ marginLeft: -3 }}>
                {lang.get("Logout")}
            </Button>
        </Box>
    )
}

export default FamilyDrawerList
